import React from 'react';
import { Link } from 'react-router-dom';

import mrm1Product from '../../../main/assets/images/mrm1-5/MRM1-5.webp';

export const Landing = () => (
  <section className="dreamX__description__content--wrapper dreamX__description__content--template-3 responsive__padding">
    <div className="dreamX__text--wrapper mrm2-landing-text-wrapper">
      <div className="dreamX__description__title__subtitle">
        <h3 className="dreamX__subtitle mrm2-landing-subtitle">
          ENGINEERED TO EXCEL
        </h3>
        <h1 className="dreamX__discover__title mrm2-landing-title">MRM1-5</h1>
      </div>
      <div className="dreamX__discover__grid--merge">
        <p className="dreamX__body mrm2-landing-description">
          The <span style={{ whiteSpace: 'nowrap' }}>MRM1-5</span> is{' '}
          <span style={{ whiteSpace: 'nowrap' }}>Orqa’s</span> multi-role
          tactical trainer. This EU-manufactured, dual-use platform features an
          adaptable design, making it an effective all-in-one solution for
          training and kinetic operations, while remaining equally capable for
          commercial and industrial applications.
        </p>

        <div className="dreamX__discover--button">
          <Link
            to="/contact?product=mrm1-5"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
    <img
      style={{ objectFit: 'contain' }}
      src={mrm1Product}
      alt="MRM1-5 Drone"
      className="mrm1-landing-product"
    />
  </section>
);
